import React from 'react';
import BlankPage from '../../../components/BlankPage';

const Gallery = () => {
  return (
    <BlankPage 
      title="Gallery Management" 
      description="Upload and manage photos and images for company events and activities." 
    />
  );
};

export default Gallery; 